/** Input must be the server-authorized story, never the trusted gateway projection.
 * Recompute from permitted canonical records instead of accepting aggregate totals.
 */ export function inferWhitespace(story) {
    const roots = new Map();
    const pursuits = new Set();
    for (const thread of story.threads){
        if (thread.membershipState !== 'active') continue;
        const root = thread.records.find((r)=>r.kind === 'opportunity' && r.id === thread.opportunityId && r.current);
        if (!root) continue;
        roots.set(root.id, root);
        for (const record of thread.records){
            if (record.kind === 'capture_project' && record.current) pursuits.add(record.id);
        }
    }
    if (roots.size === 0 || pursuits.size > 0) return [];
    return [
        {
            key: 'recorded-follow-through-v1',
            title: 'Inferred gap in recorded follow-through',
            explanation: `${roots.size} permitted Opportunity records and 0 permitted Pursuit records are represented in this active Landscape. This may be worth investigating.`,
            caveat: 'Coverage is limited to current permitted records associated with this Landscape. Missing evidence is not proof of no prior work and does not establish strategic desire. Earlier, unlinked or unavailable work may exist.',
            evidence: [
                ...roots.values()
            ].sort((a, b)=>a.id.localeCompare(b.id))
        }
    ];
}
